import { officeApi } from "./config";
import { NetworkError } from "./postapi";

const GetProject = (
  type: "prjt" | "mtup",
  filter: string,
  time: string,
  prjt_nm: string | undefined
) => {
  return officeApi
    .get(
      `/web/cstm/prjt?prjt_type_cd=${type}${filter}${time}${
        prjt_nm ? `&prjt_nm=${prjt_nm}` : ""
      }`
    )
    .then(({ data }) => {
      if (data.sts_fg) {
        return {
          state: true,
          data: data.succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          data: undefined,
          msg: data.err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

const GetDetailProject = (id: string) => {
  return officeApi
    .get(`/web/cstm/prjt/${id}`)
    .then(({ data }) => {
      if (data.sts_fg) {
        return {
          state: true,
          data: data.succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          data: undefined,
          msg: data.err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

const DeleteProject = (id: string) => {
  return officeApi
    .delete(`/cstm/prjt/${id}`)
    .then(({ data }) => {
      if (data.sts_fg) {
        return {
          state: true,
          data: data.succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          data: undefined,
          msg: data.err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

const PauseProject = (id: string) => {
  return officeApi
    .put(`/cstm/prjt/${id}/rcrt/paus`)
    .then(({ data }) => {
      if (data.sts_fg) {
        return {
          state: true,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          msg: data.err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

const ChangeBase64 = (data: string) => {
  return officeApi
    .post(`/web/cmnt/2/ctts/img`, [
      {
        img_src: data,
      },
    ])
    .then(({ data: { sts_fg, succ_obj, err_msg } }) => {
      if (sts_fg) {
        return {
          state: true,
          data: succ_obj[0].img_url,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          msg: err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

const ProjectSelectChange = (
  prjt_id: string,
  rcrt_id: string,
  apply_id: string,
  type: "select" | "reject" | "block" | "reselect"
) => {
  return officeApi
    .put(`/cstm/prjt/${prjt_id}/rcrt/${rcrt_id}/apply/${apply_id}/${type}`)
    .then(({ data: { sts_fg, succ_obj, err_msg } }) => {
      if (sts_fg) {
        return {
          state: true,
          data: succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          msg: err_msg,
        };
      }
    })
    .catch((error) => {
      console.log(error);
      return NetworkError;
    });
};
const ProjectStsChange = (prjt_id: string, type: "uning" | "ing") => {
  return officeApi
    .put(`/cstm/prjt/${prjt_id}/${type}`)
    .then(({ data: { sts_fg, succ_obj, err_msg } }) => {
      if (sts_fg) {
        return {
          state: true,
          data: succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          msg: err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

const Refund_Payment = (prjt_id: string, rcrt_id: string, apply_id: string) => {
  return officeApi
    .post(`/web/prjt/${prjt_id}/rcrt/${rcrt_id}/res/refund`, {
      apply_id,
    })
    .then(({ data: { sts_fg, succ_obj, err_msg } }) => {
      if (sts_fg) {
        return {
          state: true,
          data: succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          msg: err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

export {
  GetProject,
  DeleteProject,
  PauseProject,
  GetDetailProject,
  ChangeBase64,
  ProjectSelectChange,
  Refund_Payment,
  ProjectStsChange,
};
